import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app',
    template: require('./app.component.html'),
    styles: [require('./app.component.css')],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/app/app.component.ts